module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABGUlEQVR4Ae3VgWbEQBRG4WJQBFAEsCgGC1gUAYqi6AMU+yj7CIsCin2AAAJYFAEUCxgURTEoigCC24OAcHXSNnewOXwA/CYZc7G0ZJBDhe3gDiV+aoV7bAcb/Kkr7NFBRnocUWHcA1oIxj6xQ4FJ3SBCEjzDoUADSRDgkdQaHWSCWj0VXUz59A4BYuQIPXqEGKug1kCMPUHtC2LsBDXJ4ANqPcTYG9TeIcZeoHaAGNtB7RZi7BpqDieIkQZD+U+ph0dSh2z/jlKBMPPNcpiUR5xhTECJX1Whg/yTCA+izKP0MRlGddiAKPOoqI7JMCrCY9bWiIm3aQWTPAJE8YoSppXKu9eiQJYKtJBBDYesXaLGHg75I4fzbOkbcNYvde60S20AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/heart-filled.png
// module id = mfYp
// module chunks = 1